import React, { useEffect, useState } from "react";
import api, { showAlert } from "../../util/api";

const AdminCurrentOffice = () => {

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");

    const [form, setForm] = useState({
        status: true,
        position: "",
        office: "",
        institution: "",
        institution_label: "",
        institution_value: "",
        role_description: "",
        constituency: "",
        constituency_label: "",
        start_year: "",
        end_year: "",
        location: "",
    });


    useEffect(() => {
        fetchOffice();
    }, []);


    const fetchOffice = async () => {

        try {

            const response = await api.get("/admin/office", {
                headers: {
                    Accept: "application/json",
                },
              
            });

            const result =
                await response.data;

            if (result.success && result.data) {

                setForm({
                    status:
                        result.data.status ?? true,

                    position:
                        result.data.position || "",

                    office:
                        result.data.office || "",

                    institution:
                        result.data.institution || "",

                    institution_label:
                        result.data.institution_label || "",

                    institution_value:
                        result.data.institution_value || "",

                    role_description:
                        result.data.role_description || "",

                    constituency:
                        result.data.constituency || "",

                    constituency_label:
                        result.data.constituency_label || "",

                    start_year:
                        result.data.start_year || "",

                    end_year:
                        result.data.end_year || "",

                    location:
                        result.data.location || "",
                });
            }

        } catch (error) {

            console.error(error);

            setMessage(
                "Unable to load office information."
            );

        } finally {

            setLoading(false);
        }
    };


    const handleChange = (e) => {

        const {
            name,
            value,
            type,
            checked
        } = e.target;

        setForm(prev => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : value,
        }));
    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        setSaving(true);
        setMessage("");


        try {
            

            const response = await api.post("/admin/office", form);


            const result =
                await response.data;


            if (response.success === false) {

                throw new Error(
                    result.message ||
                    "Unable to update office."
                );
            }

            showAlert('success', 'success!', "Current office updated successfully.");

            setMessage(
                "Current office updated successfully."
            );

        } catch (error) {

            setMessage(
                error.message ||
                "Something went wrong."
            );

        } finally {

            setSaving(false);
        }
    };


    if (loading) {

        return (
            <div className="admin-page-loading">
                Loading current office...
            </div>
        );
    }


    return (
        <div className="admin-office-page">

            <div className="admin-page-header">

                <div>

                    <span className="admin-page-eyebrow">
                        WEBSITE / CURRENT OFFICE
                    </span>

                    <h2>
                        Current <em>Office.</em>
                    </h2>

                    <p>
                        Manage the politician's current
                        legislative position and tenure.
                    </p>

                </div>

                <button
                    type="submit"
                    form="office-form"
                    className="admin-primary-button"
                    disabled={saving}
                >
                    {saving
                        ? "Saving..."
                        : "Save Changes"
                    }
                </button>

            </div>


            {message && (
                <div className="admin-form-message">
                    {message}
                </div>
            )}


            <form
                id="office-form"
                onSubmit={handleSubmit}
            >

                {/* STATUS */}

                <section className="admin-panel">

                    <div className="admin-panel-header">

                        <div>

                            <span>
                                STATUS
                            </span>

                            <h3>
                                Office Status
                            </h3>

                        </div>

                    </div>


                    <div className="admin-form">

                        <label className="admin-toggle">

                            <input
                                type="checkbox"
                                name="status"
                                checked={form.status}
                                onChange={handleChange}
                            />

                            <span className="admin-toggle-slider" />

                            <div>
                                <strong>
                                    Active Office
                                </strong>

                                <small>
                                    This position is
                                    currently active.
                                </small>
                            </div>

                        </label>

                    </div>

                </section>


                {/* POSITION */}

                <section className="admin-panel admin-office-panel">

                    <div className="admin-panel-header">

                        <div>

                            <span>
                                LEGISLATIVE POSITION
                            </span>

                            <h3>
                                Office Information
                            </h3>

                        </div>

                    </div>


                    <div className="admin-form">

                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Position
                                </label>

                                <input
                                    name="position"
                                    value={form.position}
                                    onChange={handleChange}
                                    placeholder="Member"
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    Office
                                </label>

                                <input
                                    name="office"
                                    value={form.office}
                                    onChange={handleChange}
                                    placeholder="Ekiti State House of Assembly"
                                />

                            </div>

                        </div>


                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Institution
                                </label>

                                <input
                                    name="institution"
                                    value={form.institution}
                                    onChange={handleChange}
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    Assembly / Institution Value
                                </label>

                                <input
                                    name="institution_value"
                                    value={
                                        form.institution_value
                                    }
                                    onChange={handleChange}
                                    placeholder="7th Assembly"
                                />

                            </div>

                        </div>


                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Institution Label
                                </label>

                                <input
                                    name="institution_label"
                                    value={
                                        form.institution_label
                                    }
                                    onChange={handleChange}
                                    placeholder="ASSEMBLY"
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    Location
                                </label>

                                <input
                                    name="location"
                                    value={form.location}
                                    onChange={handleChange}
                                    placeholder="Igede-Ekiti, Ekiti State"
                                />

                            </div>

                        </div>

                    </div>

                </section>


                {/* ROLE */}

                <section className="admin-panel admin-office-panel">

                    <div className="admin-panel-header">

                        <div>

                            <span>
                                REPRESENTATION
                            </span>

                            <h3>
                                Role & Constituency
                            </h3>

                        </div>

                    </div>


                    <div className="admin-form">

                        <div className="admin-form-group">

                            <label>
                                Role Description
                            </label>

                            <textarea
                                name="role_description"
                                value={
                                    form.role_description
                                }
                                onChange={handleChange}
                                placeholder="Representing..."
                            />

                        </div>


                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Constituency
                                </label>

                                <input
                                    name="constituency"
                                    value={
                                        form.constituency
                                    }
                                    onChange={handleChange}
                                    placeholder="Irepodun/Ifelodun I"
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    Constituency Label
                                </label>

                                <input
                                    name="constituency_label"
                                    value={
                                        form.constituency_label
                                    }
                                    onChange={handleChange}
                                    placeholder="CONSTITUENCY"
                                />

                            </div>

                        </div>

                    </div>

                </section>


                {/* TENURE */}

                <section className="admin-panel">

                    <div className="admin-panel-header">

                        <div>

                            <span>
                                TENURE
                            </span>

                            <h3>
                                Term Information
                            </h3>

                        </div>

                    </div>


                    <div className="admin-form">

                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Start Year
                                </label>

                                <input
                                    type="number"
                                    name="start_year"
                                    value={
                                        form.start_year
                                    }
                                    onChange={handleChange}
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    End Year
                                </label>

                                <input
                                    type="number"
                                    name="end_year"
                                    value={
                                        form.end_year
                                    }
                                    onChange={handleChange}
                                />

                            </div>

                        </div>

                    </div>

                </section>

            </form>

        </div>
    );
};

export default AdminCurrentOffice;